export default {
  sectionBusiness: "Business",
  sectionAdmin: "Administration",
  sectionDesign: "Design",
  sectionSettings: "Settings",
  plannedBadge: "Coming soon",
  items: {
    home: "Home",
    myApplications: "My cases",
    approvalRequests: "Approval requests",
    notifications: "Notifications",
    allCases: "All cases",
    permissions: "My groups & permissions",
    activityLog: "Activity log",
    processDesign: "Process design",
    secrets: "Secrets & connections",
  },
} as const;
